import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth, RequireBeta } from "./components/guards.jsx";
import { ThemeToggle } from "./components/ui.jsx";

import Landing from "./pages/Landing.jsx";
import Login from "./pages/Login.jsx";
import FreePlay from "./pages/FreePlay.jsx";
import InviteWall from "./pages/InviteWall.jsx";
import KidHome from "./pages/KidHome.jsx";
import ParentGate from "./pages/ParentGate.jsx";
import ChildProfiles from "./pages/ChildProfiles.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import TaskDetail from "./pages/TaskDetail.jsx";
import PrintSheet from "./pages/PrintSheet.jsx";
import CompletionFlow from "./pages/CompletionFlow.jsx";
import Settings from "./pages/Settings.jsx";

// Route map — see plan §1.6. Kid-facing app lives under /app; the Grown-Ups' Corner
// (parents section) lives under /grown-ups behind the grown-up gate. Every authed
// route also passes RequireBeta during the invite-only public beta.
export default function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/play" element={<FreePlay />} />   {/* FREE PLAY (BETA): public, no account */}
      <Route path="/play/:skillId" element={<FreePlay />} />   {/* deep-link straight into a game */}

      <Route path="/invite" element={<RequireAuth><InviteWall /></RequireAuth>} />

      <Route path="/app" element={<RequireAuth><RequireBeta><KidHome /></RequireBeta></RequireAuth>} />
      <Route path="/app/:skillId" element={<RequireAuth><RequireBeta><KidHome /></RequireBeta></RequireAuth>} />   {/* deep-link into a game (signed-in) */}

      {/* Grown-Ups' Corner */}
      <Route path="/grown-ups" element={<RequireAuth><RequireBeta><ParentGate /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/children" element={<RequireAuth><RequireBeta><ChildProfiles /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/child/:childId" element={<RequireAuth><RequireBeta><Dashboard /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/child/:childId/task/:taskId" element={<RequireAuth><RequireBeta><TaskDetail /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/child/:childId/task/:taskId/print" element={<RequireAuth><RequireBeta><PrintSheet /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/child/:childId/task/:taskId/complete" element={<RequireAuth><RequireBeta><CompletionFlow /></RequireBeta></RequireAuth>} />
      <Route path="/grown-ups/settings" element={<RequireAuth><RequireBeta><Settings /></RequireBeta></RequireAuth>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <ThemeToggle />
    </>
  );
}
